import { render, staticRenderFns } from "./ReferralLinkBlock.vue?vue&type=template&id=4827fb0c&scoped=true&"
import script from "./ReferralLinkBlock.vue?vue&type=script&lang=js&"
export * from "./ReferralLinkBlock.vue?vue&type=script&lang=js&"
import style0 from "./ReferralLinkBlock.vue?vue&type=style&index=0&id=4827fb0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4827fb0c",
  null
  
)

export default component.exports